var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-6 offset-lg-3 col-12 p-0" }, [
          _c("div", { staticClass: "card shadow-sm" }, [
            _c("div", { staticClass: "card-header" }, [
              _c(
                "p",
                { staticClass: "text-center", staticStyle: { margin: "0px" } },
                [_vm._v("จำนวนเงินที่ขอสินเชื่อ")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [
              _c("p", [_vm._v("วงเงินสินเชื่อที่ต้องการ")]),
              _vm._v(" "),
              _c("ul", { staticClass: "ml-3" }, [
                _c("li", { staticClass: "list-style" }, [_vm._v("10,000 บาท")]),
                _vm._v(" "),
                _c("li", { staticClass: "list-style" }, [_vm._v("7,500 บาท")]),
                _vm._v(" "),
                _c("li", { staticClass: "list-style" }, [_vm._v("5,000 บาท")])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card shadow-sm" }, [
            _c("div", { staticClass: "card-body mt-1" }, [
              _c("p", { staticClass: "text-center" }, [
                _vm._v("แผนการผ่อนชำระ")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex justify-content-between box-payday" },
                [
                  _c("div", { staticClass: "bg-light px-3 day" }, [
                    _c("p", { staticClass: "text-center" }, [_vm._v(" 90 วัน")])
                  ]),
                  _vm._v(" "),
                  _c("div", {}, [
                    _c("p", { staticClass: "text-rigth px-3" }, [
                      _vm._v("40 บาท/วัน")
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex justify-content-between box-payday" },
                [
                  _c("div", { staticClass: "bg-light px-3 day" }, [
                    _c("p", { staticClass: "text-center" }, [
                      _vm._v(" 180 วัน")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", {}, [
                    _c("p", { staticClass: "text-rigth px-3" }, [
                      _vm._v("35 บาท/วัน")
                    ])
                  ])
                ]
              )
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ce6e19c6", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce6e19c6","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nimcap/Components/Guarantor/Step7.vue
// module id = 2300
// module chunks = 0